import { render, staticRenderFns } from "./SubscriptionAlert.vue?vue&type=template&id=939d948c"
import script from "./SubscriptionAlert.vue?vue&type=script&lang=js"
export * from "./SubscriptionAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports